import { render, staticRenderFns } from "./LcOrder.vue?vue&type=template&id=27f295da&scoped=true"
import script from "./LcOrder.vue?vue&type=script&lang=js"
export * from "./LcOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f295da",
  null
  
)

export default component.exports